import { render, staticRenderFns } from "./PsyhMainPage.vue?vue&type=template&id=85ceaea2&scoped=true"
import script from "./PsyhMainPage.vue?vue&type=script&lang=js"
export * from "./PsyhMainPage.vue?vue&type=script&lang=js"
import style0 from "./PsyhMainPage.vue?vue&type=style&index=0&id=85ceaea2&prod&lang=scss"
import style1 from "./PsyhMainPage.vue?vue&type=style&index=1&id=85ceaea2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85ceaea2",
  null
  
)

export default component.exports